import shop from './shop.svg';

export default function ShopIcon() {
  return <img src={shop} alt={'shop'} width="32" height="32" />;
}
